import { createBrowserRouter } from 'react-router-dom';
import App       from './App';
import Dashboard from './pages/Dashboard';
import Login     from './pages/Login';
import RequireAuth from './auth/RequireAuth';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    // Everything below /login is protected by the auth gate.
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <App />,
        children: [
          { index: true, element: <Dashboard /> },
          // Future routes can be added here:
          // { path: 'store/:id',  element: <StoreDetail /> },
        ],
      },
    ],
  },
]);

export default router;
